//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {

  },
  props:{
    label:{
      type: String,
      required: true
    }
  },
  data () {
    return {
      networksIconsKeys: {
        VKontakte: 'vk',
        //Facebook: 'fb',
        Odnoklassniki: 'ok',
        GoogleOAuth: 'google'
      }
    }
  },
  methods: {
    auth (url) {
      window.open(url, 'oauth-win', 'width=800,height=600')
    }
  },
  chimera: {
    networks: '/api/socialServicesAuth/'
  }
}
